/* eslint-disable @typescript-eslint/naming-convention */
import {DialogBackdrop} from './Backdrop/DialogBackdrop'
import {DialogPortal} from './Portal/DialogPortal'
import {DialogRoot} from './Root/DialogRoot'
import {DialogPopup} from './Popup/DialogPopup'
import {DialogTitle} from './Title/DialogTitle'
import {DialogDescription} from './Description/DialogDescription'

export namespace Dialog {
    export const Root = DialogRoot
    export const Portal = DialogPortal
    export const Backdrop = DialogBackdrop
    export const Popup = DialogPopup
    export const Title = DialogTitle
    export const Description = DialogDescription
}
